import { render, staticRenderFns } from "./AutoSelection.vue?vue&type=template&id=3dac2ce9&scoped=true"
import script from "./AutoSelection.vue?vue&type=script&lang=js"
export * from "./AutoSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac2ce9",
  null
  
)

export default component.exports